import api from "./index";
import { axios } from "@/utils/request";

export function getMasterData(parameter) {
  return axios({
    url: api.BaseURL + api.MasterData + "list",
    method: "GET",
    params: parameter,
  });
}
